module.exports = __webpack_public_path__ + "static/media/bottle_crates.a0ea9a44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/injectionMoulds/bottle_crates.jpg
// module id = 198
// module chunks = 0